import { render, staticRenderFns } from "./NoDashboardAccess.vue?vue&type=template&id=267d3c5a"
import script from "./NoDashboardAccess.vue?vue&type=script&lang=js"
export * from "./NoDashboardAccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports